/* eslint-disable camelcase */
import { BlotterColumnKey } from "@enfusion-ui/core";

const knownColumnWidths = {
  Contract: 244,
  Txn: 97,
  Quantity: 93,
  Limit: 84,
  Stop: 70,
  Type: 83,
  TIF: 66,
  Bid: 105,
  Ask: 105,
  Last: 105,
  ChangePct: 104,
  Change: 86,
  Status: 125,
  Filled: 81,
  Open: 81,
  Broker: 183,
  Destination: 212,
  Strategy: 110,
  Compliance: 122,
  Position: 92,
  AvgPx: 81,
  FilledPct: 87,
  LastFillPx: 102,
  MarketLimitDelta: 148,
  VWAP: 79,
  Volume: 86,
  VWAPShares: 118,
  FIXOrderId: 220,
  OrderId: 92,
  Trader: 105,
  BBTicker: 135,
  Ticker: 80,
  Counterparty: 117,
  StatusText: 878,
  PBDExposure: 122,
  Exposure: 95,
  ExposureChange: 139,
  OrderDate: 108,
  Idle: 81,
  Method: 103,
  SwapOrder: 109,
  ExecVal_NAV: 123,
  OpenVal_NAV: 128,
  OrderVal_NAV: 131,
  ListId: 77,
  ListSeqNo: 105,
  ListTotalNo: 113,
  ListAlias: 93,
  BrokerAccount: 128,
  NotionalTradeAmount: 172,
  SubmissionStatus: 143,
  ReleaseDateTime: 148,
  PBDFilledQty: 124,
  TodayFilledQty: 132,
  NotionalFilledAmount: 171,
  IsStale: 83,
  Ccy: 68,
  BidAskDelta: 118,
  Exchange: 140,
  _30DAvgVol: 110,
  _3MAvgVol: 105,
  _5DAvgVol: 104,
  NotionalUnfilledAmount: 184,
  OrderPctOf30D_ADV: 156,
  FilledPctOf30D_ADV: 154,
  OpenPctOf30D_ADV: 154,
  OrderPctOf3M_ADV: 151,
  FilledPctOf3M_ADV: 149,
  UnfilledPctOf3M_ADV: 162,
  LastModifiedAt: 181,
  ImpactVWAP: 119,
  ImpactVWAPShares: 158,
  FilledPctOfVWAPShares: 92,
  FilledPctOfImpactVWAPShares: 132,
  AllocationInstructions: 197,
  CounterpartyMemo: 107,
  ExecutedExposureBPS: 181,
  NotionalTradeAmountUSD: 182,
  NotionalUnfilledAmountUSD: 194,
  NotionalFilledAmountUSD: 181,
  Underlier: 96,
  FillPriceDeviation: 145,
  SODOpenQuantity: 152,
  TodayFilledPct: 122,
  WorkflowState: 129,
  FundName: 106,
  ClearingAccount: 175,
  BookName: 107,
  PortfolioManager: 138,
  Instructions: 109,
  Resumed: 95,
  InstrumentSubtype: 167,
  FirstTransmittedDate: 181,
  CompletedDate: 175,
  FirstFilledDate: 181,
  LastFilledDate: 181,
  Undecided: 114,
  CompletionStatus: 145,
  isExecutionRoute: 145,
  ParentOrderId: 129,
  CommissionRate: 108,
  CommissionRateType: 137,
  CommissionTotal: 110,
  Committed: 106,
  IsCurrentlyScheduled: 166,
  TodayAvgPx: 116,
  TodayCommitted: 141,
  SettleToBookFXRate: 87,
  Proceeds: 153,
  OrderDays: 105,
  _20DAvgVol: 110,
  RemainingVolumeOf5DAvg: 178,
  ImpactVWAPAvgPxDelta: 198,
  ShortLocateAmountApproved: 102,
  ShortLocateAmountRequested: 104,
  ShortLocateAmountAssigned: 132,
  ArrivalPrice: 110,
  ArrivalPctChange: 137,
  MaturityDate: 120,
  RIC: 95,
  OrderCreationMethod: 200,
  CalculatorType: 158,
  IsForceCancel: 125,
  ISIN: 133,
  ShortInterest: 120,
  ShortInterestPctEquityFloat: 201,
  IsUnsolicitedCancel: 156,
  DarkPools: 153,
  ArrivalVWAP: 117,
  OpenPx: 91,
  PreviousClosePx: 118,
  ExchangeCountryCode: 147,
  ExchangeCountryName: 151,
  MarketLimitDeltaPct: 161,
  FXFixingDate: 106,
  FXFarForwardDate: 138,
  FXFarFixingDate: 125,
  ChangesToAcknowledge: 128,
  TradingDesk: 115,
  AllocationReason: 142,
  TradeReason: 118,
  IsActiveParent: 129,
  CreationPrice: 121,
  TodayFilledQtyPctNav: 186,
  StrategyBook: 122,
  UndisclosedShort: 143,
  _Control_: 150,
} as const;

export default new Proxy(
  knownColumnWidths as unknown as Record<BlotterColumnKey, number>,
  {
    get: (target, key) => target[key as unknown as BlotterColumnKey] || 100,
  }
);
